import { css } from '../../common.styles';

export const MarginReset = css`
  margin: 0;
  margin-block-start: initial;
  margin-block-end: initial;
  margin-inline-start: initial;
  margin-inline-end: initial;
`;

export const HtmlHReset = css`
  ${MarginReset};
  padding: 0;
  border: 0;
  outline: 0;
  font-weight: inherit;
  font-style: inherit;
  font-size: 100%;
  font-family: inherit;
  vertical-align: baseline;
`;
